import { render, staticRenderFns } from "./StoryblokFooterWide.vue?vue&type=template&id=5120b0e8&scoped=true&"
import script from "./StoryblokFooterWide.vue?vue&type=script&lang=js&"
export * from "./StoryblokFooterWide.vue?vue&type=script&lang=js&"
import style0 from "./StoryblokFooterWide.vue?vue&type=style&index=0&id=5120b0e8&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120b0e8",
  null
  
)

export default component.exports